import { CheckCircle, XCircle } from "lucide-react";
import { caseStudyContent } from "@/app/content/landingContent";

export function CaseStudySection() {
  const { case: c } = caseStudyContent;

  return (
    <section
      id="case-study"
      className="py-20 md:py-24 px-6 bg-white"
      aria-labelledby="case-study-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <p className="text-sm font-semibold text-[#004f4f] uppercase tracking-widest mb-4">
            {c.label}
          </p>
          <h2
            id="case-study-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {caseStudyContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 leading-relaxed max-w-prose mx-auto">
            {caseStudyContent.description}
          </p>
        </div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12">
          <p className="text-sm text-slate-500 mb-10 font-medium">{c.institution}</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Before */}
            <div>
              <h3 className="flex items-center gap-2 text-lg font-semibold text-slate-700 mb-5">
                <XCircle size={20} className="text-red-500 flex-shrink-0" aria-hidden="true" />
                {c.before.heading}
              </h3>
              <ul className="space-y-3">
                {c.before.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-slate-600 text-base leading-relaxed">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-400 flex-shrink-0" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* After */}
            <div>
              <h3 className="flex items-center gap-2 text-lg font-semibold text-slate-700 mb-5">
                <CheckCircle size={20} className="text-[#004f4f] flex-shrink-0" aria-hidden="true" />
                {c.after.heading}
              </h3>
              <ul className="space-y-3">
                {c.after.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-slate-600 text-base leading-relaxed">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#004f4f] flex-shrink-0" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Metrics */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 border-t border-gray-200">
            {c.metrics.map((metric) => (
              <div key={metric.label} className="text-center">
                <dl>
                  <dt className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold text-slate-900 mb-1">
                    {metric.value}
                  </dt>
                  <dd className="text-sm text-slate-500 leading-snug">{metric.label}</dd>
                </dl>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
